"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("./Heading.scss");
var Heading = function (_a) {
    var dusk = _a.dusk, label = _a.label;
    return (react_1.default.createElement("h1", { "data-dusk": dusk, className: "heading" }, label));
};
exports.default = Heading;
//# sourceMappingURL=index.js.map